import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/homePage/icons/bullet.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/advertising/adchannel.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/advertising/industryInsights_.png");
;
import(/* webpackMode: "eager" */ "/app/public/industry/advertising/market_research.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/brand_positioning.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/customer_insights.svg");
;
import(/* webpackMode: "eager" */ "/app/public/industry/technology/technology_adoption.svg");
;
import(/* webpackMode: "eager" */ "/app/public/slm/icon/home.svg");
